import React from "react"
import { useNavigate } from "react-router-dom";
import { Menu, X, Settings, MessageSquare, HelpCircle } from "lucide-react"

export const Navbar = ({ 
  userData, 
  isDrawerOpen, 
  setIsDrawerOpen,
  isContextDrawerOpen,
  setIsContextDrawerOpen
}) => {
  const navigate = useNavigate();

  const handleOnboardingRestart = () => {
    navigate("/onboarding/intro");
  };

  return (
    <>
      <div className="flex items-center ml-4">
        <button
          onClick={() => setIsDrawerOpen(!isDrawerOpen)}
          className="mr-4 md:hidden"
        >
          <div className="relative w-5 h-5">
            <Menu
              size={20}
              className={`absolute transform transition-all duration-300 ${
                isDrawerOpen ? "opacity-0 rotate-90" : "opacity-100 rotate-0"
              }`}
            />
            <X
              size={20}
              className={`absolute transform transition-all duration-300 ${
                isDrawerOpen ? "opacity-100 rotate-0" : "opacity-0 rotate-90"
              }`}
            />
          </div>
        </button>
        <img 
          src="/images/logo-lg.svg" 
          alt="LetterAtlas" 
          className="h-8 w-auto cursor-pointer object-contain" 
          style={{ maxWidth: '160px' }}
          onClick={() => navigate("/")}
        />
      </div>
      <div className="flex items-center space-x-4">
        <button
          onClick={handleOnboardingRestart}
          className="flex items-center space-x-2 p-2 rounded-full hover:bg-gray-100"
          title="Restart Onboarding"
        >
          <HelpCircle size={20} className="text-gray-600" />
        </button>
        <button
          onClick={() => navigate("/settings")}
          className="flex items-center space-x-2 p-2 rounded-full hover:bg-gray-100"
          title="Settings"
        >
          <Settings size={20} className="text-gray-600" />
        </button>
      </div>
    </>
  )
}

export default Navbar
